<template>
  <div class="relative">
    <div class="flex flex-col">
      <div class="h-[250px] w-full bg-white"></div>
      <div class="h-[250px] md:h-[310px] w-full bg-stone-white"></div>
    </div>

    <div class="absolute inset-0 flex items-start justify-center pt-0 md:pt-14">
      <div v-if="pending" class="text-center">
        <NuxtImg class="w-20" src="/icons/loading.svg"></NuxtImg>
      </div>

      <!-- Success State -->
      <div v-if="alert.type === 'success'"
        class="bg-white shadow-card rounded-lg px-16 py-10 text-center flex flex-col justify-center w-full max-w-[692px] min-h-[300px] m-8 md:m-0">
        <h1 v-if="alert.title" class="text-2xl text-space-cadet font-bold">
          {{ alert.title }}
        </h1>
        <p v-if="alert.content" class="text-lg-30 text-dark-blue tracking-[0.22px] mb-[49px] font-normal">
          {{ alert.content }}
        </p>

        <div class="flex justify-center">
          <BaseButton :text="$t('buttons.common.login')" @buttonClicked="redirectToLogin" class="w-40" />
        </div>
      </div>

      <!-- Error State -->
      <div v-else-if="alert.type === 'error'"
        class="bg-white shadow-card rounded-lg px-16 py-10 text-center flex flex-col justify-center w-full max-w-[692px] min-h-[300px] m-8 md:m-0">
        <h1 class="text-2xl text-danger font-bold">
          {{ alert.title }}
        </h1>
        <p class="text-lg-30 text-dark-blue tracking-[0.22px] mb-[49px] font-normal">
          {{ alert.content }}
        </p>

        <div class="flex justify-center">
          <BaseButton :text="$t('buttons.common.login')" @buttonClicked="redirectToLogin" class="w-40" />
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
const { t } = useI18n();

interface Alert {
  title: string | null;
  content: string | null;
  type: "success" | "error" | null;
}

const route = useRoute();

const pending = ref(false);
const alert = reactive<Alert>({
  title: null,
  content: null,
  type: null,
});

const redirectToLogin = () => {
  navigateTo(localeUri("/account/login"));
};

onMounted(async () => {
  const userId = route.query.userId;
  const token = route.query.token;
  const expires = route.query.expires;
  const signature = route.query.signature;

  // Basic validation check
  if (!userId || !token || !expires || !signature) {
    alert.title = t("pages.account.verify-email.texts.invalid_link_title");
    alert.content = t("pages.account.verify-email.texts.invalid_link_content");
    alert.type = "error";
    return;
  }

  try {
    pending.value = true;

    await useAxios().get(`/email/verify/${userId}/${token}`, {
      params: {
        expires,
        signature,
      },
    });

    alert.title = t("pages.account.verify-email.texts.success_title");
    alert.content = t("pages.account.verify-email.texts.success_content");
    alert.type = "success";

  } catch (err: any) {
    alert.title = t("pages.account.verify-email.texts.failed_title");
    alert.content = t("pages.account.verify-email.texts.failed_content");
    alert.type = "error";

  } finally {
    pending.value = false;
  }
});
</script>
